export default __webpack_public_path__ + "static/media/mtl.5cb56540.PNG";